<template>
  <div class="text-center" :class="{full}">
    <div v-if="full">
      <img src="../../assets/icon.png" class="d-block m-auto animated flipInY infinite" alt="Logo Lecard" style="width: 92px;">
      <div class="text-white mt-3" v-if="text && text !== true" style="white-space: break-spaces">{{text}}</div>
    </div>
    <div v-else>
      <div class="lds-ellipsis"><div></div><div></div><div></div><div></div></div>
      <div class="small mt-2" v-if="text && text !== true">{{text}}</div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "loading",
    props: ['full', 'text', 'logo']
  }
</script>

<style scoped>
  .full {
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: var(--primary);
  }

  @media (max-width: 767px) {
    .full {
      align-items: start;
      padding-top: 250px;
    }
  }
</style>
